import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronDown, Search, Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { label: "Solutions", to: "/solutions", items: ["Clinical Workflow & EHR", "Smart Telehealth", "Treatment Planning", "Assessments & Screeners"] },
  { label: "For Families", to: "/for-families", items: ["Parent Portal", "Parent Coaching Hub", "Progress Tracking", "At-Home Activities"] },
  { label: "For Providers", to: "/for-providers", items: ["BCBAs & Therapists", "Pediatricians", "Schools & IEP Teams", "Care Coordination"] },
  { label: "Resources", to: "/resources", items: ["Guides & Articles", "Webinars", "Case Studies", "Help Center"] },
  { label: "About", to: "/about", items: ["Our Mission", "Leadership", "Careers", "Contact"] },
];

export default function Navbar() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur-md bg-white/80 border-b border-white/60">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <div className="flex items-center justify-between h-[86px]">
          <Logo height={62} />
          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => (
              <div key={n.label} className="relative group">
                <Link to={n.to} data-testid={`nav-${slug(n.label)}`} className="flex items-center gap-1 px-3.5 py-2 rounded-lg text-[15px] font-semibold text-[#1c2c46] hover:text-[#1a5fd0] hover:bg-[#eef5ff] transition-colors">
                  {n.label}<ChevronDown size={15} className="opacity-70 group-hover:rotate-180 transition-transform" />
                </Link>
                <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all absolute left-0 top-full pt-2 w-64">
                  <div className="card-soft p-2">
                    {n.items.map((it) => (
                      <Link key={it} to={`${n.to}#${slug(it)}`} className="block px-3.5 py-2.5 rounded-xl text-sm font-medium text-[#33425c] hover:bg-[#eef5ff] hover:text-[#1a5fd0]">{it}</Link>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            <button className="h-10 w-10 grid place-items-center rounded-full text-[#1c2c46] hover:bg-[#eef5ff]" aria-label="Search"><Search size={19} /></button>
            <Link to="/login" data-testid="nav-login" className="btn-ghost-blue px-5 py-2.5 text-[15px] font-semibold">Log In</Link>
            <Link to="/request-demo" data-testid="nav-request-demo" className="btn-primary px-5 py-2.5 text-[15px] font-semibold">Request a Demo</Link>
          </div>
          <button className="lg:hidden h-11 w-11 grid place-items-center rounded-xl text-[#1c2c46] hover:bg-[#eef5ff]" onClick={() => setOpen(!open)} aria-label="Menu">{open ? <X /> : <Menu />}</button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white px-5 py-4 space-y-1">
          {NAV.map((n) => (
            <Link key={n.label} to={n.to} className="block px-3 py-3 rounded-xl font-semibold text-[#1c2c46] hover:bg-[#eef5ff]" onClick={() => setOpen(false)}>{n.label}</Link>
          ))}
          <div className="flex gap-3 pt-2">
            <Link to="/login" className="btn-ghost-blue flex-1 text-center px-4 py-2.5 font-semibold" onClick={() => setOpen(false)}>Log In</Link>
            <Link to="/request-demo" className="btn-primary flex-1 text-center px-4 py-2.5 font-semibold" onClick={() => setOpen(false)}>Request a Demo</Link>
          </div>
        </div>
      )}
    </header>
  );
}
